import { Reveal } from "../Reveal";
import { useLang } from "../../context/LanguageContext";

export function Benefits({ items = [] }) {
  const { t } = useLang();
  if (!items.length) return null;
  return (
    <section data-testid="course-benefits" className="bg-[#E9EFFA] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto">
        <Reveal className="max-w-2xl mb-14">
          <span className="overline">{t("benefits.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0B1220] mt-3">
            {t("benefits.title")}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-14">
          {items.map((b, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <span className="font-heading text-5xl font-light text-[#5B9DFF]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-heading text-2xl text-[#0B1220] mt-4 leading-snug">{b.title}</h3>
              <p className="mt-3 text-[#5C6678] font-light leading-relaxed">{b.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
